import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export const ThemeToggle = () => {
    const [dark, setDark] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem("patr-theme");
        const prefers = window.matchMedia("(prefers-color-scheme: dark)").matches;
        const isDark = stored ? stored === "dark" : prefers;
        setDark(isDark);
        document.documentElement.classList.toggle("dark", isDark);
    }, []);

    const toggle = () => {
        const next = !dark;
        setDark(next);
        document.documentElement.classList.toggle("dark", next);
        localStorage.setItem("patr-theme", next ? "dark" : "light");
    };

    return (
        <button
            data-testid="theme-toggle-button"
            onClick={toggle}
            aria-label={dark ? "Switch to light parchment" : "Switch to dark parchment"}
            className="group flex h-9 w-9 items-center justify-center rounded-full border border-rule text-ink/70 transition-colors duration-300 hover:border-wax hover:text-wax focus:outline-none focus-visible:ring-2 focus-visible:ring-wax"
        >
            {dark ? <Sun size={16} strokeWidth={1.5} /> : <Moon size={16} strokeWidth={1.5} />}
        </button>
    );
};
